import React from 'react'
import { applyRouterMiddleware, browserHistory, Router, createRoutes } from 'react-router'
import { Provider } from 'react-redux'
import getRoutes from './routes'
import {
  pollUploads,
  fetchCurrentUser,
  uploadSpeedTest
} from './actions'
import createStore from './store'
import { useScroll } from 'react-router-scroll'

// We need a Root component for React Hot Loading.
function Root() {
  import('./misc/autotrack.custom')
  .then(() => {
    window.ga('create', 'UA-56474110-5', 'auto');
    window.ga('require', 'eventTracker');
    window.ga('require', 'urlChangeTracker');
    window.ga('send', 'pageview');
  });

  const store = createStore()	

  Promise.all([
    store.dispatch(fetchCurrentUser()),
    new Promise((resolve,reject) => window.onload = resolve),
  ]).then(() => store.dispatch(uploadSpeedTest()))

  // start polling
  setInterval(
    () => {
      store.dispatch(pollUploads())
    },
    5000,
  )

  return (
    <Provider store={store}>
      <Router
        history={browserHistory}
        routes={createRoutes(getRoutes(store))}
        render={applyRouterMiddleware(useScroll())}
      />
    </Provider>
  )
}

export default Root



// WEBPACK FOOTER //
// ./src/Root.js